import { PulseBaseProvider } from '../../base-classes';
import { getTemperatureFromCelsius } from '../../utilities/unitConversion';
import { unitSystems } from '../../utilities/units';

const _historicalObsUri = '/data/observations/v1/historical/highlowbyproviderandstation';
const _historicalObsCacheKey = 'historicalObs';

export class HistoricalObsProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_historicalObsCacheKey] = this.historicalObsSyncer.bind(this);
    }

    async historicalObsSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            startdatetimeutc: syncParams.startdatetimeutc,
            enddatetimeutc: syncParams.enddatetimeutc,
            units: unitSystems.english,
            verbose: syncParams.verbose,
            stationid: syncParams.stationid,
            providerid: syncParams.providerid
        };

        const { tempUnit } = syncParams;
        const unitConversionFunc = (result) => {
            if (result?.HistoricalHighLowObs) {
                result.HistoricalHighLowObs.forEach(resultHiLow => {
                    resultHiLow.TemperatureHighC = getTemperatureFromCelsius(resultHiLow.TemperatureHighC, tempUnit, false);
                    resultHiLow.TemperatureLowC = getTemperatureFromCelsius(resultHiLow.TemperatureLowC, tempUnit, false);
                });
            }
            return result;
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _historicalObsUri, resolve, reject, responseValidator, syncParams.pulseApi, null, unitConversionFunc);
    }

    async getHistoricalObs(startdatetimeutc, enddatetimeutc, stationid, providerid, units, stdParameters, verbose, refresh = false, lengthUnit, tempUnit, pressureUnit, speedUnit) {
        const syncParams = {
            startdatetimeutc,
            enddatetimeutc,
            stationid,
            providerid,
            units: units ? units : unitSystems.english,
            verbose: !!verbose,
            refresh,
            lengthUnit,
            tempUnit,
            pressureUnit,
            speedUnit
        };

        const id = JSON.stringify(syncParams);

        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_historicalObsCacheKey, id);
        }
        return await super.loadFromStorage(_historicalObsCacheKey, id, syncParams);
    }
}

